export function IllustrationConformiteFloue({ className }: { className?: string }) {
  return (
    <img
      className={className}
      src="/images/sourcing-atelier-001.webp"
      alt="Atelier de reconditionnement — contrôle qualité"
      loading="lazy"
      style={{ borderRadius: 'var(--radius-md)', objectFit: 'cover' }}
    />
  );
}
